import { Container, Divider, Grid, Stack } from "@mui/material";
import { ReactElement } from "react";
import { TitleView } from "./TitleView";
import { COLOR_LIGHT_GRAY, COLOR_VERY_LIGHT_GRAY } from "../../data/colors/Colors";

interface props {
  title: string;
  titleLayout?: ReactElement;
  titleLayoutAlignItems?: "start" | "center";
  titleLayoutDirection?: "row" | "column";
  layout: ReactElement;
  isLayoutFullWidthInSmallerScreens?: boolean;
  alignItems?: "start" | "center" | "end";
  hasDivider?: boolean;
}

export const HeaderView: React.FC<props> = ({
  title,
  titleLayout,
  titleLayoutAlignItems,
  titleLayoutDirection,
  layout,
  isLayoutFullWidthInSmallerScreens = true,
  alignItems,
  hasDivider = false,
}: props) => {
  return (
    <Stack>
      <Container maxWidth={false} sx={{ p: 2 }}>
        <Grid
          container
          spacing={3}
          alignItems={alignItems ? alignItems : "center"}
        >
          <Grid
            size={{
              xs: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              sm: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              md: 6,
              lg: 4,
              xl: 3,
            }}
          >
            <Stack
              direction={titleLayoutDirection ? titleLayoutDirection : "row"}
              alignItems={
                titleLayoutAlignItems ? titleLayoutAlignItems : "center"
              }
              spacing={1}
            >
              <TitleView title={title} />
              {titleLayout}
            </Stack>
          </Grid>
          <Grid
            size={{
              xs: 0,
              sm: 0,
              md: 0,
              lg: 4,
              xl: 3,
            }}
            display={{
              xs: "none",
              sm: "none",
              md: "none",
              lg: "none",
              xl: "flex",
            }}
          />
          <Grid
            size={{
              xs: 0,
              sm: 0,
              md: 0,
              lg: 4,
              xl: 3,
            }}
            display={{
              xs: "none",
              sm: "none",
              md: "none",
              lg: "flex",
              xl: "flex",
            }}
          />
          <Grid
            size={{
              xs: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              sm: isLayoutFullWidthInSmallerScreens ? 12 : 6,
              md: 6,
              lg: 4,
              xl: 3,
            }}
          >
            {layout}
          </Grid>
        </Grid>
      </Container>
      {hasDivider && <Divider sx={{background: COLOR_LIGHT_GRAY}}/>}
    </Stack>
  );
};
